import { useTitle } from "@/hooks/use-title.hook.ts";
import NotFound from "@/pages/NotFound.tsx";
import { getReportsVisibleToEmployee } from "@/pages/reporting/reporting.types.ts";
import { useEmployeeMe } from "@/queries/employees/use-employees.query.ts";
import analyticsService, { analyticEvents } from "@/services/analytics-service.ts";
import { Card, Page, Stack, Text } from "@skailer-com/uikit";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

export default function Reporting() {
  const { t } = useTranslation();
  const { data: employee } = useEmployeeMe();
  useTitle(t("common:reports"));

  const menu = useMemo(() => {
    if (!employee) return [];

    return getReportsVisibleToEmployee(employee);
  }, [employee]);

  useEffect(() => {
    analyticsService.trackEvent(analyticEvents.reporting.viewedOverview);
  }, []);

  if (employee && menu.length === 0) return <NotFound />;

  return (
    <>
      <Page>
        <Page.Header title={t("common:reports")} />

        <Page.Content>
          <Stack className={"py-10 px-16 gap-10"}>
            {menu.map((section) => (
              <Stack key={section.title} gap={"lg"}>
                <Text size={"3xl"} className={"font-semibold"}>
                  {section.title}
                </Text>
                <div className="grid md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
                  {section.items.map((item) => (
                    <Card
                      key={item.to}
                      icon={item.icon}
                      header={item.title}
                      caption={item.description}
                      to={item.to}
                    />
                  ))}
                </div>
              </Stack>
            ))}
          </Stack>
        </Page.Content>
      </Page>
    </>
  );
}
